import React, { useMemo } from 'react';
import { TagInfo } from '../../types';

import style from './index.module.scss';

export const HashtagOption = ({
  data,
  search,
  prefix,
}: {
  data: TagInfo;
  search: string;
  prefix: '#' | '$';
}) => {
  const { matchSearchText, leftPart } = useMemo(() => {
    if (data?.name.startsWith(search)) {
      return {
        matchSearchText: search,
        leftPart: data.name.slice(search.length),
      };
    }

    return {
      matchSearchText: '',
      leftPart: data.name,
    };
  }, [data.name, search]);
  return (
    <div className={style.optionContainer}>
      {prefix}
      {matchSearchText}
      <span className={style.leftPart}>{leftPart}</span>
    </div>
  );
};
